"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));
/* -*- tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- /
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */

/*
   Copyright 2011 notmasteryet
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
// - The JPEG specification can be found in the ITU CCITT Recommendation T.81
//   (www.w3.org/Graphics/JPEG/itu-t81.pdf)
// - The JFIF specification can be found in the JPEG File Interchange Format
//   (www.w3.org/Graphics/JPEG/jfif3.pdf)
// - The Adobe Application-Specific JPEG markers in the Supporting the DCT Filters
//   in PostScript Level 2, Technical Note #5116
//   (partners.adobe.com/public/developer/en/ps/sdk/5116.DCT_Filter.pdf)


var dctZigZag = new Int32Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
var dctCos1 = 4017; // cos(pi/16)

var dctSin1 = 799; // sin(pi/16)

var dctCos3 = 3406; // cos(3*pi/16)

var dctSin3 = 2276; // sin(3*pi/16)

var dctCos6 = 1567; // cos(6*pi/16)

var dctSin6 = 3784; // sin(6*pi/16)

var dctSqrt2 = 5793; // sqrt(2)

var dctSqrt1d2 = 2896; // sqrt(2) / 2

function buildHuffmanTable(codeLengths, values) {
  var k = 0;
  var code = [];
  var length = 16;

  while (length > 0 && !codeLengths[length - 1]) {
    --length;
  }

  code.push({
    children: [],
    index: 0
  });
  var p = code[0];
  var q;

  for (var i = 0; i < length; i++) {
    for (var j = 0; j < codeLengths[i]; j++) {
      p = code.pop();
      p.children[p.index] = values[k];

      while (p.index > 0) {
        p = code.pop();
      }

      p.index++;
      code.push(p);

      while (code.length <= i) {
        code.push(q = {
          children: [],
          index: 0
        });
        p.children[p.index] = q.children;
        p = q;
      }

      k++;
    }

    if (i + 1 < length) {
      // p here points to last code
      code.push(q = {
        children: [],
        index: 0
      });
      p.children[p.index] = q.children;
      p = q;
    }
  }

  return code[0].children;
}

function decodeScan(data, initialOffset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive) {
  var mcusPerLine = frame.mcusPerLine,
      progressive = frame.progressive;
  var startOffset = initialOffset;
  var offset = initialOffset;
  var bitsData = 0;
  var bitsCount = 0;

  function readBit() {
    if (bitsCount > 0) {
      bitsCount--;
      return bitsData >> bitsCount & 1;
    }

    bitsData = data[offset++];

    if (bitsData === 0xFF) {
      var nextByte = data[offset++];

      if (nextByte) {
        throw new Error("unexpected marker: ".concat((bitsData << 8 | nextByte).toString(16)));
      } // unstuff 0

    }

    bitsCount = 7;
    return bitsData >>> 7;
  }

  function decodeHuffman(tree) {
    var node = tree;
    var bit;

    while ((bit = readBit()) !== null) {
      // eslint-disable-line no-cond-assign
      node = node[bit];

      if (typeof node === 'number') {
        return node;
      }

      if ((0, _typeof2.default)(node) !== 'object') {
        throw new Error('invalid huffman sequence');
      }
    }

    return null;
  }

  function receive(initialLength) {
    var length = initialLength;
    var n = 0;

    while (length > 0) {
      var bit = readBit();

      if (bit === null) {
        return undefined;
      }

      n = n << 1 | bit;
      --length;
    }

    return n;
  }

  function receiveAndExtend(length) {
    var n = receive(length);

    if (n >= 1 << length - 1) {
      return n;
    }

    return n + (-1 << length) + 1;
  }

  function decodeBaseline(component, zz) {
    var t = decodeHuffman(component.huffmanTableDC);
    var diff = t === 0 ? 0 : receiveAndExtend(t);
    component.pred += diff;
    zz[0] = component.pred;
    var k = 1;

    while (k < 64) {
      var rs = decodeHuffman(component.huffmanTableAC);
      var s = rs & 15;
      var r = rs >> 4;

      if (s === 0) {
        if (r < 15) {
          break;
        }

        k += 16;
      } else {
        k += r;
        var z = dctZigZag[k];
        zz[z] = receiveAndExtend(s);
        k++;
      }
    }
  }

  function decodeDCFirst(component, zz) {
    var t = decodeHuffman(component.huffmanTableDC);
    var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
    component.pred += diff;
    zz[0] = component.pred;
  }

  function decodeDCSuccessive(component, zz) {
    zz[0] |= readBit() << successive;
  }

  var eobrun = 0;

  function decodeACFirst(component, zz) {
    if (eobrun > 0) {
      eobrun--;
      return;
    }

    var k = spectralStart;
    var e = spectralEnd;

    while (k <= e) {
      var rs = decodeHuffman(component.huffmanTableAC);
      var s = rs & 15;
      var r = rs >> 4;

      if (s === 0) {
        if (r < 15) {
          eobrun = receive(r) + (1 << r) - 1;
          break;
        }

        k += 16;
      } else {
        k += r;
        var z = dctZigZag[k];
        zz[z] = receiveAndExtend(s) * (1 << successive);
        k++;
      }
    }
  }

  var successiveACState = 0;
  var successiveACNextValue;

  function decodeACSuccessive(component, zz) {
    var k = spectralStart;
    var e = spectralEnd;
    var r = 0;

    while (k <= e) {
      var z = dctZigZag[k];
      var direction = zz[z] < 0 ? -1 : 1;

      switch (successiveACState) {
        case 0:
          {
            // initial state
            var rs = decodeHuffman(component.huffmanTableAC);
            var s = rs & 15;
            r = rs >> 4;

            if (s === 0) {
              if (r < 15) {
                eobrun = receive(r) + (1 << r);
                successiveACState = 4;
              } else {
                r = 16;
                successiveACState = 1;
              }
            } else {
              if (s !== 1) {
                throw new Error('invalid ACn encoding');
              }

              successiveACNextValue = receiveAndExtend(s);
              successiveACState = r ? 2 : 3;
            }

            continue; // eslint-disable-line no-continue
          }

        case 1: // skipping r zero items

        case 2:
          if (zz[z]) {
            zz[z] += (readBit() << successive) * direction;
          } else {
            r--;

            if (r === 0) {
              successiveACState = successiveACState === 2 ? 3 : 0;
            }
          }

          break;

        case 3:
          // set value for a zero item
          if (zz[z]) {
            zz[z] += (readBit() << successive) * direction;
          } else {
            zz[z] = successiveACNextValue << successive;
            successiveACState = 0;
          }

          break;

        case 4:
          // eob
          if (zz[z]) {
            zz[z] += (readBit() << successive) * direction;
          }

          break;

        default:
          break;
      }

      k++;
    }

    if (successiveACState === 4) {
      eobrun--;

      if (eobrun === 0) {
        successiveACState = 0;
      }
    }
  }

  function decodeMcu(component, decodeFunction, mcu, row, col) {
    var mcuRow = mcu / mcusPerLine | 0;
    var mcuCol = mcu % mcusPerLine;
    var blockRow = mcuRow * component.v + row;
    var blockCol = mcuCol * component.h + col;
    decodeFunction(component, component.blocks[blockRow][blockCol]);
  }

  function decodeBlock(component, decodeFunction, mcu) {
    var blockRow = mcu / component.blocksPerLine | 0;
    var blockCol = mcu % component.blocksPerLine;
    decodeFunction(component, component.blocks[blockRow][blockCol]);
  }

  var componentsLength = components.length;
  var component;
  var i;
  var j;
  var k;
  var n;
  var decodeFn;

  if (progressive) {
    if (spectralStart === 0) {
      decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
    } else {
      decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
    }
  } else {
    decodeFn = decodeBaseline;
  }

  var mcu = 0;
  var marker;
  var mcuExpected;

  if (componentsLength === 1) {
    mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
  } else {
    mcuExpected = mcusPerLine * frame.mcusPerColumn;
  }

  var usedResetInterval = resetInterval || mcuExpected;

  while (mcu < mcuExpected) {
    // reset interval stuff
    for (i = 0; i < componentsLength; i++) {
      components[i].pred = 0;
    }

    eobrun = 0;

    if (componentsLength === 1) {
      component = components[0];

      for (n = 0; n < usedResetInterval; n++) {
        decodeBlock(component, decodeFn, mcu);
        mcu++;
      }
    } else {
      for (n = 0; n < usedResetInterval; n++) {
        for (i = 0; i < componentsLength; i++) {
          component = components[i];
          var _component = component,
              h = _component.h,
              v = _component.v;

          for (j = 0; j < v; j++) {
            for (k = 0; k < h; k++) {
              decodeMcu(component, decodeFn, mcu, j, k);
            }
          }
        }

        mcu++; // If we've reached our expected MCU's, stop decoding

        if (mcu === mcuExpected) {
          break;
        }
      }
    } // find marker


    bitsCount = 0;
    marker = data[offset] << 8 | data[offset + 1];

    if (marker < 0xFF00) {
      throw new Error('marker was not found');
    }

    if (marker >= 0xFFD0 && marker <= 0xFFD7) {
      // RSTx
      offset += 2;
    } else {
      break;
    }
  }

  return offset - startOffset;
}

function buildComponentData(frame, component) {
  var lines = [];
  var blocksPerLine = component.blocksPerLine,
      blocksPerColumn = component.blocksPerColumn;
  var samplesPerLine = blocksPerLine << 3;
  var R = new Int32Array(64);
  var r = new Uint8Array(64); // A port of poppler's IDCT method which in turn is taken from:
  //   Christoph Loeffler, Adriaan Ligtenberg, George S. Moschytz,
  //   "Practical Fast 1-D DCT Algorithms with 11 Multiplications",
  //   IEEE Intl. Conf. on Acoustics, Speech & Signal Processing, 1989,
  //   988-991.

  function quantizeAndInverse(zz, dataOut, dataIn) {
    var qt = component.quantizationTable;
    var v0;
    var v1;
    var v2;
    var v3;
    var v4;
    var v5;
    var v6;
    var v7;
    var t;
    var p = dataIn;
    var i; // dequant

    for (i = 0; i < 64; i++) {
      p[i] = zz[i] * qt[i];
    } // inverse DCT on rows


    for (i = 0; i < 8; ++i) {
      var row = 8 * i; // check for all-zero AC coefficients

      if (p[1 + row] === 0 && p[2 + row] === 0 && p[3 + row] === 0 && p[4 + row] === 0 && p[5 + row] === 0 && p[6 + row] === 0 && p[7 + row] === 0) {
        t = dctSqrt2 * p[0 + row] + 512 >> 10;
        p[0 + row] = t;
        p[1 + row] = t;
        p[2 + row] = t;
        p[3 + row] = t;
        p[4 + row] = t;
        p[5 + row] = t;
        p[6 + row] = t;
        p[7 + row] = t;
        continue; // eslint-disable-line no-continue
      } // stage 4


      v0 = dctSqrt2 * p[0 + row] + 128 >> 8;
      v1 = dctSqrt2 * p[4 + row] + 128 >> 8;
      v2 = p[2 + row];
      v3 = p[6 + row];
      v4 = dctSqrt1d2 * (p[1 + row] - p[7 + row]) + 128 >> 8;
      v7 = dctSqrt1d2 * (p[1 + row] + p[7 + row]) + 128 >> 8;
      v5 = p[3 + row] << 4;
      v6 = p[5 + row] << 4; // stage 3

      t = v0 - v1 + 1 >> 1;
      v0 = v0 + v1 + 1 >> 1;
      v1 = t;
      t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
      v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
      v3 = t;
      t = v4 - v6 + 1 >> 1;
      v4 = v4 + v6 + 1 >> 1;
      v6 = t;
      t = v7 + v5 + 1 >> 1;
      v5 = v7 - v5 + 1 >> 1;
      v7 = t; // stage 2

      t = v0 - v3 + 1 >> 1;
      v0 = v0 + v3 + 1 >> 1;
      v3 = t;
      t = v1 - v2 + 1 >> 1;
      v1 = v1 + v2 + 1 >> 1;
      v2 = t;
      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
      v7 = t;
      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
      v6 = t; // stage 1

      p[0 + row] = v0 + v7;
      p[7 + row] = v0 - v7;
      p[1 + row] = v1 + v6;
      p[6 + row] = v1 - v6;
      p[2 + row] = v2 + v5;
      p[5 + row] = v2 - v5;
      p[3 + row] = v3 + v4;
      p[4 + row] = v3 - v4;
    } // inverse DCT on columns


    for (i = 0; i < 8; ++i) {
      var col = i; // check for all-zero AC coefficients

      if (p[1 * 8 + col] === 0 && p[2 * 8 + col] === 0 && p[3 * 8 + col] === 0 && p[4 * 8 + col] === 0 && p[5 * 8 + col] === 0 && p[6 * 8 + col] === 0 && p[7 * 8 + col] === 0) {
        t = dctSqrt2 * dataIn[i + 0] + 8192 >> 14;
        p[0 * 8 + col] = t;
        p[1 * 8 + col] = t;
        p[2 * 8 + col] = t;
        p[3 * 8 + col] = t;
        p[4 * 8 + col] = t;
        p[5 * 8 + col] = t;
        p[6 * 8 + col] = t;
        p[7 * 8 + col] = t;
        continue; // eslint-disable-line no-continue
      } // stage 4


      v0 = dctSqrt2 * p[0 * 8 + col] + 2048 >> 12;
      v1 = dctSqrt2 * p[4 * 8 + col] + 2048 >> 12;
      v2 = p[2 * 8 + col];
      v3 = p[6 * 8 + col];
      v4 = dctSqrt1d2 * (p[1 * 8 + col] - p[7 * 8 + col]) + 2048 >> 12;
      v7 = dctSqrt1d2 * (p[1 * 8 + col] + p[7 * 8 + col]) + 2048 >> 12;
      v5 = p[3 * 8 + col];
      v6 = p[5 * 8 + col]; // stage 3

      t = v0 - v1 + 1 >> 1;
      v0 = v0 + v1 + 1 >> 1;
      v1 = t;
      t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
      v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
      v3 = t;
      t = v4 - v6 + 1 >> 1;
      v4 = v4 + v6 + 1 >> 1;
      v6 = t;
      t = v7 + v5 + 1 >> 1;
      v5 = v7 - v5 + 1 >> 1;
      v7 = t; // stage 2

      t = v0 - v3 + 1 >> 1;
      v0 = v0 + v3 + 1 >> 1;
      v3 = t;
      t = v1 - v2 + 1 >> 1;
      v1 = v1 + v2 + 1 >> 1;
      v2 = t;
      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
      v7 = t;
      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
      v6 = t; // stage 1

      p[0 * 8 + col] = v0 + v7;
      p[7 * 8 + col] = v0 - v7;
      p[1 * 8 + col] = v1 + v6;
      p[6 * 8 + col] = v1 - v6;
      p[2 * 8 + col] = v2 + v5;
      p[5 * 8 + col] = v2 - v5;
      p[3 * 8 + col] = v3 + v4;
      p[4 * 8 + col] = v3 - v4;
    } // convert to 8-bit integers


    for (i = 0; i < 64; ++i) {
      var sample = 128 + (p[i] + 8 >> 4);

      if (sample < 0) {
        dataOut[i] = 0;
      } else if (sample > 0XFF) {
        dataOut[i] = 0xFF;
      } else {
        dataOut[i] = sample;
      }
    }
  }

  for (var blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
    var scanLine = blockRow << 3;

    for (var i = 0; i < 8; i++) {
      lines.push(new Uint8Array(samplesPerLine));
    }

    for (var blockCol = 0; blockCol < blocksPerLine; blockCol++) {
      quantizeAndInverse(component.blocks[blockRow][blockCol], r, R);
      var offset = 0;
      var sample = blockCol << 3;

      for (var j = 0; j < 8; j++) {
        var line = lines[scanLine + j];

        for (var _i = 0; _i < 8; _i++) {
          line[sample + _i] = r[offset++];
        }
      }
    }
  }

  return lines;
}

var JpegStreamReader = /*#__PURE__*/function () {
  function JpegStreamReader() {
    (0, _classCallCheck2.default)(this, JpegStreamReader);
    this.jfif = null;
    this.adobe = null;
    this.quantizationTables = [];
    this.huffmanTablesAC = [];
    this.huffmanTablesDC = [];
    this.resetFrames();
  }

  (0, _createClass2.default)(JpegStreamReader, [{
    key: "resetFrames",
    value: function resetFrames() {
      this.frames = [];
    }
  }, {
    key: "parse",
    value: function parse(data) {
      var offset = 0; // const { length } = data;

      function readUint16() {
        var value = data[offset] << 8 | data[offset + 1];
        offset += 2;
        return value;
      }

      function readDataBlock() {
        var length = readUint16();
        var array = data.subarray(offset, offset + length - 2);
        offset += array.length;
        return array;
      }

      function prepareComponents(frame) {
        var maxH = 0;
        var maxV = 0;
        var component;
        var componentId;

        for (componentId in frame.components) {
          if (frame.components.hasOwnProperty(componentId)) {
            component = frame.components[componentId];

            if (maxH < component.h) {
              maxH = component.h;
            }

            if (maxV < component.v) {
              maxV = component.v;
            }
          }
        }

        var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / maxH);
        var mcusPerColumn = Math.ceil(frame.scanLines / 8 / maxV);

        for (componentId in frame.components) {
          if (frame.components.hasOwnProperty(componentId)) {
            component = frame.components[componentId];
            var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / maxH);
            var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / maxV);
            var blocksPerLineForMcu = mcusPerLine * component.h;
            var blocksPerColumnForMcu = mcusPerColumn * component.v;
            var blocks = [];

            for (var i = 0; i < blocksPerColumnForMcu; i++) {
              var row = [];

              for (var j = 0; j < blocksPerLineForMcu; j++) {
                row.push(new Int32Array(64));
              }

              blocks.push(row);
            }

            component.blocksPerLine = blocksPerLine;
            component.blocksPerColumn = blocksPerColumn;
            component.blocks = blocks;
          }
        }

        frame.maxH = maxH;
        frame.maxV = maxV;
        frame.mcusPerLine = mcusPerLine;
        frame.mcusPerColumn = mcusPerColumn;
      }

      var fileMarker = readUint16();

      if (fileMarker !== 0xFFD8) {
        // SOI (Start of Image)
        throw new Error('SOI not found');
      }

      fileMarker = readUint16();

      while (fileMarker !== 0xFFD9) {
        // EOI (End of image)
        switch (fileMarker) {
          case 0xFF00:
            break;

          case 0xFFE0: // APP0 (Application Specific)

          case 0xFFE1: // APP1

          case 0xFFE2: // APP2

          case 0xFFE3: // APP3

          case 0xFFE4: // APP4

          case 0xFFE5: // APP5

          case 0xFFE6: // APP6

          case 0xFFE7: // APP7

          case 0xFFE8: // APP8

          case 0xFFE9: // APP9

          case 0xFFEA: // APP10

          case 0xFFEB: // APP11

          case 0xFFEC: // APP12

          case 0xFFED: // APP13

          case 0xFFEE: // APP14

          case 0xFFEF: // APP15

          case 0xFFFE:
            {
              // COM (Comment)
              var appData = readDataBlock();

              if (fileMarker === 0xFFE0) {
                if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) {
                  // 'JFIF\x00'
                  this.jfif = {
                    version: {
                      major: appData[5],
                      minor: appData[6]
                    },
                    densityUnits: appData[7],
                    xDensity: appData[8] << 8 | appData[9],
                    yDensity: appData[10] << 8 | appData[11],
                    thumbWidth: appData[12],
                    thumbHeight: appData[13],
                    thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                  };
                }
              } // TODO APP1 - Exif


              if (fileMarker === 0xFFEE) {
                if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65 && appData[5] === 0) {
                  // 'Adobe\x00'
                  this.adobe = {
                    version: appData[6],
                    flags0: appData[7] << 8 | appData[8],
                    flags1: appData[9] << 8 | appData[10],
                    transformCode: appData[11]
                  };
                }
              }

              break;
            }

          case 0xFFDB:
            {
              // DQT (Define Quantization Tables)
              var quantizationTablesLength = readUint16();
              var quantizationTablesEnd = quantizationTablesLength + offset - 2;

              while (offset < quantizationTablesEnd) {
                var quantizationTableSpec = data[offset++];
                var tableData = new Int32Array(64);

                if (quantizationTableSpec >> 4 === 0) {
                  // 8 bit values
                  for (var j = 0; j < 64; j++) {
                    var z = dctZigZag[j];
                    tableData[z] = data[offset++];
                  }
                } else if (quantizationTableSpec >> 4 === 1) {
                  // 16 bit
                  for (var _j = 0; _j < 64; _j++) {
                    var _z = dctZigZag[_j];
                    tableData[_z] = readUint16();
                  }
                } else {
                  throw new Error('DQT: invalid table spec');
                }

                this.quantizationTables[quantizationTableSpec & 15] = tableData;
              }

              break;
            }

          case 0xFFC0: // SOF0 (Start of Frame, Baseline DCT)

          case 0xFFC1: // SOF1 (Start of Frame, Extended DCT)

          case 0xFFC2:
            {
              // SOF2 (Start of Frame, Progressive DCT)
              readUint16(); // skip data length

              var frame = {
                extended: fileMarker === 0xFFC1,
                progressive: fileMarker === 0xFFC2,
                precision: data[offset++],
                scanLines: readUint16(),
                samplesPerLine: readUint16(),
                components: {},
                componentsOrder: []
              };
              var componentsCount = data[offset++];
              var componentId = void 0; // let maxH = 0;
              // let maxV = 0;

              for (var i = 0; i < componentsCount; i++) {
                componentId = data[offset];
                var h = data[offset + 1] >> 4;
                var v = data[offset + 1] & 15;
                var qId = data[offset + 2];
                frame.componentsOrder.push(componentId);
                frame.components[componentId] = {
                  h: h,
                  v: v,
                  quantizationIdx: qId
                };
                offset += 3;
              }

              prepareComponents(frame);
              this.frames.push(frame);
              break;
            }

          case 0xFFC4:
            {
              // DHT (Define Huffman Tables)
              var huffmanLength = readUint16();

              for (var _i2 = 2; _i2 < huffmanLength;) {
                var huffmanTableSpec = data[offset++];
                var codeLengths = new Uint8Array(16);
                var codeLengthSum = 0;

                for (var _j2 = 0; _j2 < 16; _j2++, offset++) {
                  codeLengths[_j2] = data[offset];
                  codeLengthSum += codeLengths[_j2];
                }

                var huffmanValues = new Uint8Array(codeLengthSum);

                for (var _j3 = 0; _j3 < codeLengthSum; _j3++, offset++) {
                  huffmanValues[_j3] = data[offset];
                }

                _i2 += 17 + codeLengthSum;

                if (huffmanTableSpec >> 4 === 0) {
                  this.huffmanTablesDC[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                } else {
                  this.huffmanTablesAC[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                }
              }

              break;
            }

          case 0xFFDD:
            // DRI (Define Restart Interval)
            readUint16(); // skip data length

            this.resetInterval = readUint16();
            break;

          case 0xFFDA:
            {
              // SOS (Start of Scan)
              readUint16(); // skip length

              var selectorsCount = data[offset++];
              var components = [];
              var _frame = this.frames[0];

              for (var _i3 = 0; _i3 < selectorsCount; _i3++) {
                var component = _frame.components[data[offset++]];
                var tableSpec = data[offset++];
                component.huffmanTableDC = this.huffmanTablesDC[tableSpec >> 4];
                component.huffmanTableAC = this.huffmanTablesAC[tableSpec & 15];
                components.push(component);
              }

              var spectralStart = data[offset++];
              var spectralEnd = data[offset++];
              var successiveApproximation = data[offset++];
              var processed = decodeScan(data, offset, _frame, components, this.resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15);
              offset += processed;
              break;
            }

          case 0xFFFF:
            // Fill bytes
            if (data[offset] !== 0xFF) {
              // Avoid skipping a valid marker.
              offset--;
            }

            break;

          default:
            if (data[offset - 3] === 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
              // could be incorrect encoding -- last 0xFF byte of the previous
              // block was eaten by the encoder
              offset -= 3;
              break;
            }

            throw new Error("unknown JPEG marker ".concat(fileMarker.toString(16)));
        }

        fileMarker = readUint16();
      }
    }
  }, {
    key: "getResult",
    value: function getResult() {
      var frames = this.frames;

      if (this.frames.length === 0) {
        throw new Error('no frames were decoded');
      } else if (this.frames.length > 1) {
        console.warn('more than one frame is not supported');
      } // set each frame's components quantization table


      for (var i = 0; i < this.frames.length; i++) {
        var cp = this.frames[i].components;

        for (var _i4 = 0, _Object$keys = Object.keys(cp); _i4 < _Object$keys.length; _i4++) {
          var j = _Object$keys[_i4];
          cp[j].quantizationTable = this.quantizationTables[cp[j].quantizationIdx];
          delete cp[j].quantizationIdx;
        }
      }

      var frame = frames[0];
      var components = frame.components,
          componentsOrder = frame.componentsOrder;
      var outComponents = [];
      var width = frame.samplesPerLine;
      var height = frame.scanLines;

      for (var i = 0; i < componentsOrder.length; i++) {
        var component = components[componentsOrder[i]];
        outComponents.push({
          lines: buildComponentData(frame, component),
          scaleX: component.h / frame.maxH,
          scaleY: component.v / frame.maxV
        });
      }

      var out = new Uint8Array(width * height * outComponents.length);
      var oi = 0;

      for (var y = 0; y < height; ++y) {
        for (var x = 0; x < width; ++x) {
          for (var _i5 = 0; _i5 < outComponents.length; ++_i5) {
            var _component2 = outComponents[_i5];
            out[oi] = _component2.lines[0 | y * _component2.scaleY][0 | x * _component2.scaleX];
            ++oi;
          }
        }
      }

      return out;
    }
  }]);
  return JpegStreamReader;
}();

var JpegDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(JpegDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(JpegDecoder);

  function JpegDecoder(fileDirectory) {
    var _this;

    (0, _classCallCheck2.default)(this, JpegDecoder);
    _this = _super.call(this);
    _this.reader = new JpegStreamReader();

    if (fileDirectory.JPEGTables) {
      _this.reader.parse(fileDirectory.JPEGTables);
    }

    return _this;
  }

  (0, _createClass2.default)(JpegDecoder, [{
    key: "decodeBlock",
    value: function decodeBlock(buffer) {
      this.reader.resetFrames();
      this.reader.parse(new Uint8Array(buffer));
      return this.reader.getResult().buffer;
    }
  }]);
  return JpegDecoder;
}(basedecoder_js_1.default);

exports.default = JpegDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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